// src/components/grid-footer.tsx
import React from 'react';
import { GridFooterContainer, GridFooter as MuiGridFooter } from '@mui/x-data-grid-pro';
import { Box } from '@material-ui/core';
import VersionInfoButton from './version-info-button';

/**
 * Custom footer component for DataGridPro
 * Extends the default footer with a version info button on the left side
 */
const GridFooter: React.FC = () => {
  return (
    <GridFooterContainer>
      <Box display="flex" alignItems="center" width="100%">
        {/* Version Info Button on the left */}
        <Box display="flex" alignItems="center" paddingLeft={1}>
          <VersionInfoButton />
        </Box>
        
        {/* Default footer content (pagination, row count, etc.) */}
        <Box flex={1}>
          <MuiGridFooter />
        </Box>
      </Box>
    </GridFooterContainer>
  );
};

export default GridFooter;
